// MarketStrip — NIFTY/BANKNIFTY/SENSEX live ticker strip (Angel One light theme)
import React from 'react';
import { useIndexData } from '../../../hooks/useMarketData';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';

export default function MarketStrip() {
  const indices = useIndexData();

  return (
    <div className="flex items-center gap-0 bg-white border-b border-gray-200 overflow-x-auto no-scrollbar">
      {indices.map((idx, i) => {
        const ltp = idx.data?.ltp;
        const close = idx.data?.close;
        const change = ltp && close ? ltp - close : (idx.data?.change || 0);
        const changePct = idx.data?.changePct || (close && change ? (change / close) * 100 : 0);
        const isUp = change >= 0;

        return (
          <div key={idx.name} className={`flex items-center gap-2 px-4 py-2 min-w-fit ${i > 0 ? 'border-l border-gray-100' : ''}`}>
            <span className="text-[11px] font-medium text-gray-500 whitespace-nowrap">{idx.name}</span>
            <span className="text-xs font-bold text-gray-900 font-mono">
              {ltp ? ltp.toLocaleString('en-IN', { maximumFractionDigits: 2 }) : '—'}
            </span>
            {ltp ? (
              <span className={`flex items-center gap-0.5 text-[11px] font-medium font-mono ${isUp ? 'text-green-600' : 'text-red-500'}`}>
                {isUp ? <FaArrowUp className="text-[7px]" /> : <FaArrowDown className="text-[7px]" />}
                {Math.abs(change).toFixed(2)} ({Math.abs(changePct).toFixed(2)}%)
              </span>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
